import { action } from 'satcheljs';

export const submitEvidenceDocument = action('submitEvidenceDocument', (setDocumentUploadStatus, documentContent: FormData) => ({
  setDocumentUploadStatus,
  documentContent,
}));

export const fetchAppealHistory = action('fetchAppealHistory');
